const inicialState = {
  mensagem: '',
};

export default inicialState;



// WEBPACK FOOTER //
// ./src/app/common/avisos/avisos.state.js